import React, { useState } from "react"
import PropTypes from "prop-types"
import { StyledField, EyeIcon, PasswordWrapper } from "./styles"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye } from "@fortawesome/pro-regular-svg-icons"

const PasswordField = ({ handleInputChange, ...rest }) => {
  const [showPassword, setShowPassword] = useState(false)

  const onChange = (event) => {
    const { name, value } = event.target
    if (handleInputChange !== undefined) handleInputChange(name, value)
  }

  return (
    <PasswordWrapper>
      <StyledField type={!!showPassword ? "text" : "password"} onChange={onChange} {...rest} />
      <EyeIcon showPassword={showPassword}>
        <FontAwesomeIcon
          icon={faEye}
          onClick={() => {
            setShowPassword(!showPassword)
          }}
        />
      </EyeIcon>
    </PasswordWrapper>
  )
}

PasswordField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  showValidation: PropTypes.bool.isRequired,
  invalid: PropTypes.bool
}

PasswordField.defaultProps = {
  handleInputChange: undefined,
  showValidation: false,
  invalid: false
}

export default PasswordField
